import styled from 'styled-components';

const FooterWrapper = styled.footer`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  width: 100%;
  box-sizing: border-box; /* Ensures padding doesn't cause overflow */
  background-color: #262626; /* Adjust as needed */
  color: #f2f2f2;
  bottom: 0; /* Align to the bottom of the viewport */
  left: 0;
  margin-top: auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
  }
`;

const FooterText = styled.p`
  margin: 0;
  font-size: 14px;
`;

const FooterButton = styled.a`
  display: inline-block;
  padding: 10px 20px;
  font-size: 14px;
  color: #f2f2f2;
  background: #444;
  border-radius: 30px;
  text-decoration: none;
  text-align: center;
  font-weight: bold;
  transition: background 0.3s ease, color 0.3s ease;

  &:hover {
    background: #f2f2f2;
    color: #262626;
  }

  &::after {
    content: " →";
  }

  @media (max-width: 768px) {
    width: 80%; /* Adjust width for mobile */
    text-align: center;
    margin-top: 10px;
  }
`;

function Footer() {
  return (
    <FooterWrapper>
      <FooterText>© Marcha World 2024</FooterText>
      <FooterButton href="mailto:majj.johnson@gmail.com">Contact</FooterButton>
    </FooterWrapper>
  );
}

export default Footer;
